import { Button, styled, Typography } from '@mui/material'
import type { TypographyProps } from '@mui/material'
import type { FC, ReactElement } from 'react'

import { LinkUnstyled, unit } from '@hcr/ui'

import { useUserDetails } from '../../../../contexts'
import { useHeroQuery } from '../../../../hooks/api/optimizely/queries'

import { HeaderHomeContainer } from './HeaderHomeContainer'
import { HeaderHomeLoading } from './HeaderHomeLoading'

export const HeaderHome: FC = () => {
  const userDetails = useUserDetails()
  const isOwner = userDetails?.data?.has_active_contracts
  const hero = useHeroQuery({ isOwner: !!isOwner })

  if (hero.isSuccess) {
    return (
      <HeaderHomeContainer>
        <Heading component='h1' variant='displayM' isOwner={!!isOwner}>
          {hero.data.heading}
        </Heading>
        <Subheading component='h2' variant='displayS' marginBottom={unit(2.5)}>
          {hero.data.subHeading}
        </Subheading>
        <Ingress component='h3' variant='bodyM' marginBottom={unit(5)}>
          {hero.data.ingress}
        </Ingress>
        <HeaderButton
          component={LinkUnstyled}
          to={hero.data.cta1Link.url}
          target={hero.data.cta1Link.target}
          variant='outlined'
          color='white'
        >
          {hero.data.cta1Link.label}
        </HeaderButton>
        {hero.data.cta2Link && (
          <HeaderButton
            component={LinkUnstyled}
            to={hero.data.cta2Link.url}
            target={hero.data.cta2Link.target}
            variant='outlined'
            color='white'
            sx={{ marginTop: unit(2.5) }}
          >
            {hero.data.cta2Link.label}
          </HeaderButton>
        )}
      </HeaderHomeContainer>
    )
  }

  return <HeaderHomeLoading />
}

type HeadingProps = TypographyProps<'h1', { isOwner: boolean }>

const Heading = styled(Typography, { shouldForwardProp: prop => prop !== 'isOwner' })<{ isOwner: boolean }>`
  font-size: ${({ isOwner }) => (isOwner ? unit(13.5) : unit(11.5))};
  line-height: ${({ isOwner }) => (isOwner ? unit(14) : unit(12))};
  margin-bottom: ${unit(2.5)};
` as (props: HeadingProps) => ReactElement

const Subheading = styled(Typography)`
  letter-spacing: ${unit(0.1)};
` as typeof Typography

const Ingress = styled(Typography)`
  letter-spacing: ${unit(0)};
` as typeof Typography

const HeaderButton = styled(Button)`
  line-height: ${unit(5)};
` as typeof Button
